/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const VideoRecorder1 = ({ className }) => {
  return (
    <svg
      className={`video-recorder-1 ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M18.3334 7.4428C18.3334 6.93795 18.3334 6.68553 18.2335 6.56864C18.1469 6.46722 18.017 6.4134 17.884 6.42386C17.7308 6.43592 17.5523 6.61441 17.1953 6.97139L14.1667 9.99999L17.1953 13.0286C17.5523 13.3856 17.7308 13.5641 17.884 13.5761C18.017 13.5866 18.1469 13.5328 18.2335 13.4313C18.3334 13.3145 18.3334 13.062 18.3334 12.5572V7.4428Z"
        stroke="#175CD3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        className="path"
        d="M1.66669 8.16666C1.66669 6.76653 1.66669 6.06646 1.93917 5.53168C2.17885 5.06128 2.56131 4.67882 3.03171 4.43914C3.56649 4.16666 4.26656 4.16666 5.66669 4.16666H10.1667C11.5668 4.16666 12.2669 4.16666 12.8017 4.43914C13.2721 4.67882 13.6545 5.06128 13.8942 5.53168C14.1667 6.06646 14.1667 6.76653 14.1667 8.16666V11.8333C14.1667 13.2335 14.1667 13.9335 13.8942 14.4683C13.6545 14.9387 13.2721 15.3212 12.8017 15.5608C12.2669 15.8333 11.5668 15.8333 10.1667 15.8333H5.66669C4.26656 15.8333 3.56649 15.8333 3.03171 15.5608C2.56131 15.3212 2.17885 14.9387 1.93917 14.4683C1.66669 13.9335 1.66669 13.2335 1.66669 11.8333V8.16666Z"
        stroke="#175CD3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};
